import React from "react";
import "./CartIcon.css";
import { FiShoppingCart } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function CartIcon({ ...cart }) {
  const navigate = useNavigate();
  const hasProperties = Object.keys(cart).length > 0;

  const handleNavigateToCart = () => {
    navigate("/cart");
  };

  return (
    <div className="cartIconWrapper" onClick={handleNavigateToCart}>
      <FiShoppingCart
        className="cartIcon"
      />
      {hasProperties && cart.cartitem_set.length > 0 && (
        <div className="cartBadge centeredFlex">
          <span>{cart.cartitem_set.length}</span>
        </div>
      )}
    </div>
  );
}
